// Contact.js

import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
//import { faAt, faPhone, faMapMarker, faFacebookF } from '@fortawesome/fontawesome-free-solid'
import { faAt, faPhone, faMapMarker} from '@fortawesome/free-solid-svg-icons'
class Contact extends Component {
  render() {
    return (
      <div class="contentView">
      <h2>Beiseker Arena</h2>
      <p><a href="https://goo.gl/maps/yyFViEY42Fp"><span><FontAwesomeIcon icon={faMapMarker} /></span> 410 5 Street, Beiseker, AB</a></p>
      <p><a href="tel:4039473855"><span><FontAwesomeIcon icon={faPhone} /></span> (403) 947-3855</a></p>
      <p><a href="mailto:ice@beisekerhockey.ca"><span><FontAwesomeIcon icon={faAt} /></span> ice@beisekerhockey.ca</a></p>


      <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2490.0315259832114!2d-113.5341311843177!3d51.384098627532104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5373eb2115fb181f%3A0xcc96b42208404a60!2sBeiseker+Arena!5e0!3m2!1sen!2sca!4v1535744385297" width="600" height="450" frameborder="0" styles="border:0" allowfullscreen></iframe>
      <div>
      <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
      </div>
      </div>
    );
  }
}

export default Contact;




// WEBPACK FOOTER //
// ./src/components/Contact.js